import * as React from 'react';
import * as styles from './styles.css';

import { RadioButtonGroup as MobileTabsTabsUIKit } from '@cian/ui-kit';

import { ETabs } from '../../types/redux/tabs';

export interface ITabs {
  value: ETabs;
  label: string;
}

export interface ITabsProps {
  onChange(e: React.ChangeEvent<HTMLInputElement>, tab: ETabs): void;
  activeTab: ETabs;
  tabs: ITabs[];
}

export function MobileTabs({ tabs, activeTab, onChange }: ITabsProps) {
  return (
    <div className={styles['container']}>
      <MobileTabsTabsUIKit options={tabs} value={activeTab} onChange={onChange} />
    </div>
  );
}
